export class TicketCount {
    total?: number;
    inprogress?: number;
    closed?: number;
    open?: number;
    pending?: number;
}